/**
 * Ryan O'Dowd
 * 2022-08-28
 * © Copyright 2022 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({fonts, globalScale, colors}) => {
  return {
    firstRow: {
      display: 'flex',
      flexDirection: 'row',
    },
    textWrapper: {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      width: '100%',
      color: colors.white,
    },
    titleAndTypeWrapper: {
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
    title: {
      flexShrink: 1,
      fontSize: globalScale * 18,
      color: colors.white,
      fontFamily: fonts.secondaryBold,
    },
    description: {
      width: '100%',
      flexWrap: 'wrap',
      fontSize: globalScale * 16,
      color: colors.white,
      opacity: 0.8,
      marginBottom: globalScale * 8,
    },
    goalTypeButton: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
    goalTypeIcon: {
      fontSize: globalScale * 20,
      color: colors.white,
    },
    userCountWrapper: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
    },
    userCount: {
      fontSize: globalScale * 14,
      color: colors.white,
    },
    statsWrapper: {
      flex: 1,
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingTop: globalScale * 4,
      paddingLeft: globalScale * 8,
      paddingBottom: globalScale * 8,
    },
    statText: {
      color: colors.accent,
      fontSize: globalScale * 18,
      marginRight: globalScale * 8,
    },
    statIcon: {
      fontSize: globalScale * 18,
      color: colors.accent,
    },
    lastRow: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginTop: globalScale * 8,
    },
    addButton: {
      marginRight: globalScale * 8,
    },
    tagsWrapper: { // @TODO: this should be horizontally scrollable if there are a lot
      flexDirection: 'row',
    },
  };
};

export default getStyles;
